/**
 * 工作流程 列表
 * @type {{}}
 */
import Vue from "vue";
import { Input, Icon, Select, Option, Message, Page, Modal,Button,Card,Dropdown,DropdownMenu,DropdownItem,Spin,CheckboxGroup,Checkbox } from "view-design";
import {
    getProcessListService,
    delProcessListService,
    updateProcessListNameService,
    getProcessExportService,
    uploadWorkFlowService,
    processDate,
    processStatus, updateWorkFlowStatusService
} from "@/service/workflow-service";
import { mapMutations, mapState } from "vuex";
import { downLoadBatch } from "@/utils/tools";
import { onAsynUploadFiles } from "@/utils/request-function";
import { systemUploadType } from "@/service/system-service";
import { getFileUploadProgressService } from "@/service/device-info-service";
Vue.component('Input', Input);
Vue.component('Icon', Icon);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Page', Page);
Vue.component('Modal', Modal);
Vue.component('Button', Button);
Vue.component('Card', Card);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Spin', Spin);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Checkbox', Checkbox);
const ProcessList = {
    name:'ProcessList',
    computed: {
        ...mapState({
            menuVisible: state => state.system.menuVisible, //菜单显示状态
        }),
    },
    data() {
        return {
            processLoading:false, //loading
            processDate:processDate, //流程时间分类
            processStatus:processStatus, //流程状态
            processListArray:{}, //列表数据
            processName:'', //工作流名称
            processHeight:0,
            checkAllGroup:[],
            checkAll: false,
            completeAsync:0,
            speedList:[], //上传文件临时存储
            speedVisible:false, //上传进度可显示
            processListParams:{ //提交的数据集
                sortType:'', //时间排序
                status:'', //流程状态
                currentPage: 1,  //当前页
                displayNumber:9 // 显示条数
            },
        }
    },
    created() {
        this.onProcessList().then()
        this.onTableHeight()
    },
    mounted() {
        window.addEventListener('resize', this.onTableHeight)
    },
    methods: {
        ...mapMutations('system',['SET_FLOW_ID']),
        /**
         * 计算table高度
         */
        onTableHeight(){
            this.processHeight = window.innerHeight - 173
            this.windowWidth = window.innerWidth
        },
        handleCheckAll (data) {
            this.checkAll = data
            if (this.checkAll) {
                for(let i in this.processListArray.content){
                    let resultRegular = this.checkAllGroup.some(item =>{
                        if(item === this.processListArray.content[i].id){
                            return true
                        }
                    })
                    if(!resultRegular){
                        this.checkAllGroup.push(this.processListArray.content[i].id)
                    }
                }
            } else {
                this.checkAllGroup = [];
            }
        },
        checkAllGroupChange(data){
            if(data.length === (this.processListParams.currentPage * this.processListParams.displayNumber)){
                this.checkAll = true;
            }else if (data.length > 0) {
                this.checkAll = false;
            }else{
                this.checkAll = false;
            }
            this.$forceUpdate()
        },
        /**
         * 搜索
         */
        onSearch(){
            this.onProcessList().then()
        },
        /**
         * 新增
         */
        onAddList() {
            this.SET_FLOW_ID('')
            this.$router.push('/workflow/config')
        },
        /**
         * 重置
         */
        onReset() {
            this.processListParams.status = ''
            this.onProcessList().then()
        },
        onExport(){
            if(this.checkAllGroup.length === 0){
                Message.warning('请选择要导出的流程！')
                return;
            }
            this.onParamExportService(this.checkAllGroup).then()
        },
        /**
         * 导出
         * @param id
         */
        onExportId(id){
            this.onParamExportService([id]).then()
        },
        /**
         * 修改名称状态
         * @param key
         */
        onUpdateNameStatus(key,obj) {
            if(obj.publishUseNum > 0){
                Message.warning('此流程已经被工作任务引用，不可重命名！')
                return
            }
            this.processListArray.content[key].nameStatus = true
            this.processName = obj.flowName
            this.$nextTick(()=>{
                this.$refs['flowName'][0].focus();
            })
        },
        /**
         * 跳转工作流配置
         * @param obj
         */
        onEditLinks(obj) {
            this.SET_FLOW_ID(obj.id)
            this.$router.push('/workflow/config')
        },
        /**
         * 修改名称
         * @param key
         */
        onUpdateName(id,key){
            this.processListArray.content[key].nameStatus = false
            if(this.processName === this.processListArray.content[key].flowName){
                return
            }
            if(this.processListArray.content[key].flowName === ''){
                Message.warning('请输入名称！')
                this.processListArray.content[key].nameStatus = true
                this.$nextTick(()=>{
                    this.$refs['flowName'][0].focus();
                })
                return
            }
            this.onUpdateProcessListName(id,key).then()
        },
        /**
         * 删除
         * @param obj
         */
        onDelete(obj) {
            if(obj.publishUseNum > 0){
                Message.warning('此流程已经被工作任务引用，不可删除！')
                return
            }
            Modal.confirm({
                title: '提示',
                content: '<p>您确定要删除这条信息吗？</p>',
                onOk: () => {
                    this.onDelProcessList(obj.id).then()
                }
            });
        },
        /**
         * 发布
         */
        onRelease(id,status) {
            this.onUpdateWorkFlowStatus(id,status).then()
        },
        /**
         * 发送当前页
         * @param number
         */
        onSearchPage(number){
            this.processListParams.currentPage = number
            this.onProcessList().then()
        },
        /**
         * 发送每页显示的条数
         * @param number
         */
        onSearchPageSize(number){
            this.processListParams.displayNumber = number
            this.onProcessList().then()
        },
        onAreAllArray(arr1,arr2){
            return arr1.every(item => arr2.includes(item));
        },
        /**
         * 获取工作流程列表
         */
        async onProcessList() {
            try {
                this.processLoading = true
                this.processListArray = {}
                let params = {
                    sortType:this.processListParams.sortType,
                    status:this.processListParams.status,
                    size:this.processListParams.displayNumber,
                    page:this.processListParams.currentPage
                }
                const { code,data } = await getProcessListService(params)
                if(code === 'SUCCESS'){
                    for(let i in data.content){
                        data.content[i].nameStatus = false
                    }
                    this.processListArray = data

                    let list = []
                    for(let i in data.content){
                        list.push(data.content[i].id)
                    }
                    if(this.checkAllGroup.length!==0){
                        if(this.onAreAllArray(list,this.checkAllGroup)){
                            this.checkAll = true
                        }else{
                            this.checkAll = false
                        }
                    }
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.processLoading = false
            }catch (error){
                this.processLoading = false
                console.log(error)
            }
        },
        /**
         * 删除任务列表
         */
        async onDelProcessList(id) {
            try {
                let params = {
                    id:id
                }
                const { code } = await delProcessListService(params)
                if(code === 'SUCCESS'){
                    Message.success('删除成功！')
                    this.onProcessList().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }

            }catch (error){
                console.log(error)
            }
        },
        /**
         * 修改工作流名称
         */
        async onUpdateProcessListName(id,key) {
            try {
                let params = {
                    id:id,
                    flowName:this.processListArray.content[key].flowName
                }
                const { code } = await updateProcessListNameService(params)
                if(code === 'SUCCESS'){
                    Message.success('修改成功！')
                    this.processListArray.content[key].nameStatus = false
                }else if(code === 'WORK_FOLW_NAME_IS_REPEAT'){
                    Message.warning('工作流名称不能与其他工作流名称相同！')
                    this.processListArray.content[key].nameStatus = true
                    this.$nextTick(()=>{
                        this.$refs['flowName'][0].focus();
                    })
                }else{
                    this.processListArray.content[key].nameStatus = true
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 工作流更新发布状态
         */
        async onUpdateWorkFlowStatus(id,status) {
            try {
                let params = {
                    id:id,
                    status:status
                }
                const { code } = await updateWorkFlowStatusService(params)
                if(code === 'SUCCESS'){
                    if(status === 1 ){
                        Message.success('发布成功！')
                    }
                    if(status === 0 ){
                        Message.success('撤回成功！')
                    }
                    for(let i in this.processListArray.content){
                        if(id === this.processListArray.content[i].id){
                            this.processListArray.content[i].status = status
                        }
                    }
                }else if(code === 'WORK_TASKS_CYCLE_START_TIME_ERROR'){
                    Message.error('开始时间已过任务状态,不可发布！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 导出技术参数数据
         */
        async onParamExportService(list) {
            try {
                let params = {
                    idList:list
                }
                const  data  = await getProcessExportService(params)
                downLoadBatch('工作流程数据',data)
                this.checkAllGroup = []
                this.checkAll = false
            }catch (error){
                this.failureExportLoading = false
                console.log(error)
            }
        },
        /**
         * 上传资料文件
         * @param event
         * @param n
         */
        onFileDataChange(event,n){
            const file =  event.target.files;
            // if (file.size > 100 * 1024 * 1024) {
            //     Message.error('请选择100M以内的文件!')
            //     return
            // }
            for(let i in file){
                // if(n === 2 && ['image/png', 'image/jpg', 'image/gif', 'image/jpeg'].includes(file[i].type)){
                //     Message.warning('请上传正确的图片')
                //     return
                // }
                if(file[i].size > 2048 * 1024 * 1024){
                    Message.warning(file[i].name+'文件不可超过2G!')
                    this.$refs[`dataInputer${n}`].value = ''
                    return
                }
                if((file[i].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file[i].type === 'application/msword') && n!==0){
                    Message.warning('不可上传.doc、.docx文件！')
                    this.$refs[`dataInputer${n}`].value = ''
                    return
                }
            }
            this.speedList = []
            this.speedList = file
            this.speedVisible = true
            this.completeAsync = 0
            onAsynUploadFiles(file,systemUploadType.knowledge_image).then((data)=>{
                let fileName = []
                for(let i in data){
                    fileName.push(data[i].resourceName)
                }
                this.onFileUploadProgressService(fileName,n).then()
                console.log(33333)
            }).catch(()=>{
                this.speedVisible = false
                this.complete = 0
                this.$refs[`dataInputer${n}`].value = ''
                Message.error('上传失败，请重新尝试！')
            })
        },
        /**
         * 文件上传 进度查询
         */
        async onFileUploadProgressService(resourceNames,n) {
            try {
                let params = {
                    resourceNames:resourceNames,
                }
                const { code,data } = await getFileUploadProgressService(params)
                if(code === 'SUCCESS'){
                    if(data === 100){
                        this.completeAsync = 100
                        this.onUploadWorkFlowService(resourceNames,n).then(()=>{
                            this.$refs[`dataInputer${n}`].value = ''
                        })
                    }else{
                        if(data>=this.completeAsync){
                            this.completeAsync = data
                        }
                        setTimeout(()=>{
                            this.onFileUploadProgressService(resourceNames,n).then()
                        },2000)
                    }
                }else if(code === 'FILE_UPLOAD_FAILED'){
                    Message.error('上传失败,请重新尝试！')
                    this.speedVisible = false
                    this.$refs[`dataInputer${n}`].value = ''
                }else{
                    Message.error('请求异常，请联系管理员！')
                }

            }catch (error){
                console.log(error)
            }
        },
        /**
         * 添加工作流程
         */
        async onUploadWorkFlowService(resourceName) {
            try {
                this.processLoading = true
                let params = {
                    fileRouteList:resourceName
                }
                const { code,data } = await uploadWorkFlowService(params)
                if(code === 'SUCCESS'){
                    this.complete = 100
                    if(data.length !== 0){
                        Message.warning('名称重复，未添加成功！')
                    }else{
                        Message.success('添加成功！')
                        this.onProcessList().then()
                    }
                }else if(code === 'FOLDER_NAME_EXIST'){
                    Message.warning('创建失败，文件名已存在！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.processLoading = false
            }catch (error){
                this.processLoading = false
                console.log(error)
            }
        },
    },
    destroyed () {
        window.removeEventListener('resize',this.onTableHeight)
    }
}
export default ProcessList
